import { useParams } from "react-router";
import { SignatureList } from "./SignatureList.tsx";

export const SignatureListFromUrlParam = () => {
  const { projectId } = useParams();
  if (!projectId) {
    return "Missing URL parameter 'projectId'";
  }
  return <SignatureList projectId={projectId} />;
};
